// src/components/recipients/ViewInvitation.tsx
import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * Legacy “/recipients/:uniqueCode” route — now a thin redirect
 * to the canonical “/invite/:uniqueCode” page.  All Firestore
 *  and tracking logic lives in InviteRouter.
 *
 * ▸ Preserves any query-string (?id=…, etc.).
 * ▸ Uses searchParams.size for clarity.
 * ▸ Includes a simple loop-protection guard.
 */
const ViewInvitation: React.FC = () => {
  const navigate = useNavigate();
  const { uniqueCode } = useParams<{ uniqueCode: string }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!uniqueCode) return;

    // Optional micro-guard against redirect loops.
    if (searchParams.get('redirected') === '1') return;

    const qs = searchParams.size ? `?${searchParams}` : '';
    navigate(`/invite/${uniqueCode}${qs}`, { replace: true });
  }, [uniqueCode, searchParams, navigate]);

  return null; // component disappears after redirect
};

export default ViewInvitation;
